import { ChangeDetectorRef, Component, NgZone, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonIcon } from '@ionic/angular/standalone';
import { Router } from '@angular/router';
import { InfoTooltipComponent } from '../../components/info-tooltip/info-tooltip.component';
import { addIcons } from 'ionicons';
import { trashOutline } from 'ionicons/icons';
import { AccountService } from '../../services/account.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-delete-account-page',
  standalone: true,
  imports: [FormsModule, IonIcon, InfoTooltipComponent],
  templateUrl: './delete-account-page.component.html',
  styleUrls: ['./delete-account-page.component.scss']
})
export class DeleteAccountPageComponent {
  private readonly ngZone = inject(NgZone);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  deleteAccountForm = {
    password: '',
    confirmation: ''
  };

  isDeletingAccount = false;
  deleteAccountError = '';

  constructor(
    private readonly accountService: AccountService,
    private readonly authService: AuthService,
    private readonly router: Router
  ) {
    addIcons({ trashOutline });
  }

  deleteAccount(): void {
    this.deleteAccountError = '';

    if (this.deleteAccountForm.confirmation !== 'DELETE') {
      this.deleteAccountError = 'Type DELETE in the confirmation field to continue.';
      return;
    }

    if (!this.deleteAccountForm.password.trim()) {
      this.deleteAccountError = 'Password is required to delete your account.';
      return;
    }

    if (!window.confirm('This will permanently delete your account and all saved account data. Continue?')) {
      return;
    }

    this.isDeletingAccount = true;

    this.accountService.deleteAccount({
      password: this.deleteAccountForm.password,
      confirmation: 'DELETE'
    }).subscribe({
      next: () => {
        this.authService.logout().subscribe(() => {
          this.runInAngular(() => {
            void this.router.navigate(['/login']);
          });
        });
      },
      error: (error: { message?: string }) => {
        this.runInAngular(() => {
          this.deleteAccountError = error.message || 'Could not delete account.';
          this.isDeletingAccount = false;
        });
      }
    });
  }

  private runInAngular(callback: () => void): void {
    this.ngZone.run(() => {
      callback();
      this.changeDetectorRef.detectChanges();
    });
  }
}
